<template>
  <div class="d-flex justify-content-around flex-column align-items-center">
    <img src="@/assets/img/logo_nextgen.png" class="w-size mb-2" />
    <h5 class="mx-md-auto">Powered by Ethos</h5>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped>
.w-size {
  width: 100% !important;
}

@media (min-width: 576px) {
  .w-size {
    width: 85% !important;
  }
}

@media (min-width: 768px) {
  .w-size {
    width: 65% !important;
  }
}
</style>
